module.exports = __webpack_public_path__ + "static/control-work-696163a934e4369673070ceb0e8c5aac.svg";